import { render, staticRenderFns, recyclableRender, components } from "./u-overlay.vue?vue&type=template&id=2d8262d9&scoped=true&"
var renderjs
import script from "./u-overlay.vue?vue&type=script&lang=js&"
export * from "./u-overlay.vue?vue&type=script&lang=js&"
import style0 from "./u-overlay.vue?vue&type=style&index=0&id=2d8262d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8262d9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-overlay/u-overlay.vue"
export default component.exports